import React, { Fragment } from "react";
import Header from "../components/Header";
import PageHeader from "../components/PageHeader";
import PR from "../components/PressRelease";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";

const Doctors = () => {
  return (
    <Fragment>
      <Header />
      <PageHeader
        bgImg={require("../assets/img/media/press-release-full.jpg")}
        title="Press Release"
        content=""
      />
      <PR />
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default Doctors;
